export function linkToSkuManagement() {
  return "/sku-management";
}
export function linkToViewSkusForVmp({ vmpId }) {
  return `${linkToSkuManagement()}/${vmpId}/view`;
}
export function linkToViewSkusForAmp({ vmpId, ampId }) {
  return `${linkToSkuManagement()}/${vmpId}/${ampId}/view`;
}
export function linkToAddSkuForVmp({ vmpId }) {
  return `${linkToSkuManagement()}/${vmpId}/add-sku`;
}
export function linkToAddSkuForAmp({ vmpId, ampId }) {
  return `${linkToSkuManagement()}/${vmpId}/${ampId}/add-sku`;
}
export function linkToAddSkuForNonPharma({
  nonPharmaId,
}: {
  nonPharmaId: string;
}) {
  return `${linkToSkuManagement()}/non-pharma/${nonPharmaId}/add-sku`;
}

export function linkToBulkSkuManagement() {
  return `${linkToSkuManagement()}/bulk/sku`;
}

export function linkToBulkSupplierManagement() {
  return `${linkToSkuManagement()}/bulk/supplier`;
}
